import type { Access, Group } from '../types';

import { useUserGroupsQuery } from './use-user-groups-query';
import { extractSpaceIdsRead, hasGroupWithScopeAllRead } from './utils';

export const selectSpaceReadAccess = (groups: Group[]): Access => {
  const hasReadAllSpacesAccess = hasGroupWithScopeAllRead(groups);
  const spaceIdsWithReadAccess = extractSpaceIdsRead(groups);
  return {
    hasReadAllSpacesAccess,
    readAccessGroups: hasReadAllSpacesAccess ? ['all'] : spaceIdsWithReadAccess,
  };
};

export const useSpaceReadAccess = () => {
  return useUserGroupsQuery<Access>(selectSpaceReadAccess);
};
